import * as React from 'react';
import SignUpPageView from '../layouts/SignUpPageView';
import { Snackbar } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export interface SignUpPageProps {
  onComponentDidMount: () => void;
  onSubmit: () => void;
  onLogin: () => void;
  btnElement: string;
  btnType: string;
  saveCustomerName: (customername: string) => void;
  saveCustomerType: (customerType: string) => void;
  saveFirstname: (customerFirstName: string) => void;
  saveLastname: (customerLastName: string) => void;
  saveEmail: (customerEmail: string) => void;
  // savePhonenumber: (customerNumber: string) => void;
  saveAddressOne: (customerAddressOne: string) => void;
  saveAddressTwo: (customerAddressTwo: string) => void;
  saveCountry: (customerCountry: string) => void;
  saveState: (customerState: string) => void;
  saveProduct: (customerProduct: string) => void;
  saveScanner: (customerScanner: string) => void;
  saveCommand: (customerCommand: string) => void;
  saveCity: (customercity: string) => void;
  saveZipcode: (customerzipcode: string) => void; // Not there
  savePoc: (customerpoc: string) => void; // Not there
  savePocemail: (customerpocemail: string) => void; // Not there
  savePocphonenumber: (customerpocphonenumber: string) => void; // Not there
  saveProductportfolio: (customerproductportfolio: string) => void; // Not there
  saveDesignsoftware: (customerdesignsoftware: string) => void; // Not there
  saveVersionofsoftware: (customerversionsoftware: string) => void; // Not there
  saveTurnaroundservice: (customerturnaroundservice: string) => void; // Not there
  savePreferenceform: (customerpreferenceform: File) => void; // Not there
  saveMaterialfiles: (customermaterialfiles: File) => void; // Not there
  saveTrunaroundservice: (customerturnaroundservice: string) => void;
  errorMessage: string;
  errorBar: boolean;
  successMessage: string;
  successBar: boolean;
  handleClose: () => void;
  handleCloseOpen: () => void;
  customername: string;
  customertype: string;
  customerfirstname: string;
  contactPhonenumber: string;
  customeremail: string;
  customerphonenumber: string;
  customeraddressone: string;
  customeraddresstwo: string;
  customercountry: string;
  customerstate: string;
  customerproduct: string;
  customerscanner: string;
  customercommand: string;
  customercity: string;
  customerzipcode: string;
  customerpoc: string;
  customerpocemail: string;
  customerpocphonenumber: string;
  customerproductportfolio: string;
  customerdesignsoftware: string;
  customerversionofsoftware: string;
  customerturnaroundservice: string;
  customerpreferenceform: File;
  customermaterialfiles: File;
}

class SignUpPage extends React.Component<SignUpPageProps> {
  render() {
    return (
      <div>
        <SignUpPageView
          saveCustomerName={this.props.saveCustomerName}
          saveCustomerType={this.props.saveCustomerType}
          saveFirstname={this.props.saveFirstname}
          saveLastname={this.props.saveLastname}
          saveEmail={this.props.saveEmail}
          // savePhonenumber={this.props.savePhonenumber}
          saveAddressOne={this.props.saveAddressOne}
          saveAddressTwo={this.props.saveAddressTwo}
          saveCountry={this.props.saveCountry}
          saveState={this.props.saveState}
          saveProduct={this.props.saveProduct}
          saveScanner={this.props.saveScanner}
          saveCommand={this.props.saveCommand}
          saveCity={this.props.saveCity}
          saveZipcode={this.props.saveZipcode}
          savePoc={this.props.savePoc}
          savePocemail={this.props.savePocemail}
          savePocphonenumber={this.props.savePocphonenumber}
          saveProductportfolio={this.props.saveProductportfolio}
          saveDesignsoftware={this.props.saveDesignsoftware}
          saveVersionofsoftware={this.props.saveVersionofsoftware}
          saveTrunaroundservice={this.props.saveTrunaroundservice}
          savePreferenceform={this.props.savePreferenceform}
          saveMaterialfiles={this.props.saveMaterialfiles}
          onSubmit={this.props.onSubmit}
          onLogin={this.props.onLogin}

          customername={this.props.customername}
          customertype={this.props.customertype}
          customerfirstname={this.props.customerfirstname}
          contactPhonenumber={this.props.contactPhonenumber}
          customeremail={this.props.customeremail}
          // customerphonenumber={this.props.customerphonenumber}
          customeraddressone={this.props.customeraddressone}
          customeraddresstwo={this.props.customeraddresstwo}
          customercountry={this.props.customercountry}
          customerstate={this.props.customerstate}
          customerproduct={this.props.customerproduct}
          customerscanner={this.props.customerscanner}
          customercommand={this.props.customercommand}
          customercity={this.props.customercity}
          customerzipcode={this.props.customerzipcode}
          customerpoc={this.props.customerpoc}
          customerpocemail={this.props.customerpocemail}
          customerpocphonenumber={this.props.customerpocphonenumber}
          customerproductportfolio={this.props.customerproductportfolio}
          customerdesignsoftware={this.props.customerdesignsoftware}
          customerversionofsoftware={this.props.customerversionofsoftware}
          customerturnaroundservice={this.props.customerturnaroundservice}
          customerpreferenceform={this.props.customerpreferenceform}
          customermaterialfiles={this.props.customermaterialfiles}
        />
        <Snackbar
          open={this.props.errorBar}
          autoHideDuration={2000}
          onClose={this.props.handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="error"
          >
            <AlertTitle>Error</AlertTitle>
            {this.props.errorMessage}
          </Alert>
        </Snackbar>
        <Snackbar
          open={this.props.successBar}
          autoHideDuration={6000}
          onClose={this.props.handleCloseOpen}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
        >
          <Alert
            severity="success"
          >
            <AlertTitle>Success</AlertTitle>
            {this.props.successMessage}
            <React.Fragment>
              <Button color="inherit" size="small" onClick={this.props.handleCloseOpen}>
                Back to Sign In
              </Button>
            </React.Fragment>
          </Alert>
        </Snackbar>
      </div>
    );
  }
  componentDidMount() {
    this.props.onComponentDidMount();
  }
}

export default SignUpPage;



// WEBPACK FOOTER //
// ./src/components/signup/SignUpPage.tsx